/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/daysSelect.scss';

import React, {MouseEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

import {AwesomeIcon, ChangeFunction, Checkbox, WithBackground} from '@dvrd/dvr-controls';

import {BolmateButton} from '../../controls';

interface Props {
    onChange: ChangeFunction<number>;
    onChangeOnlyWorkDays: ChangeFunction<boolean>;
    onClose: MouseEventHandler;
    onSubmit: MouseEventHandler;
    days: number;
    active: boolean;
    onlyWorkDays: boolean;
}

export default function DaysSelect(props: Props) {
    const {t} = useTranslation();
    const {days, onClose, active, onChange, onSubmit, onChangeOnlyWorkDays, onlyWorkDays} = props;

    function onPlus() {
        onChange(days + 1);
    }

    function onMin() {
        onChange(days - 1);
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='days-select default-popup'>
                <div className='header-container'>
                    <label className='header-title'>{t('email.day.title', 'Aangepast aantal dagen')}</label>
                </div>
                <div className='body-container'>
                    <div className='days-container'>
                        <div className='number-control' onClick={onMin}>
                            <AwesomeIcon name='minus' className='control-icon' />
                        </div>
                        <label className='days'>{days}</label>
                        <div className='number-control' onClick={onPlus}>
                            <AwesomeIcon name='plus' className='control-icon' />
                        </div>
                    </div>
                    <div className='work-days'>
                        <Checkbox
                            checked={onlyWorkDays}
                            onCheck={onChangeOnlyWorkDays}
                            label={t('email.day.onlyWorkDays', 'Alleen werkdagen')}
                        />
                    </div>
                </div>
                <div className='footer-container'>
                    <BolmateButton onClick={onClose} label={t('email.day.cancel', 'Annuleren')} secondary />
                    <BolmateButton onClick={onSubmit} label={t('email.day.confirm', 'Bevestigen')} />
                </div>
            </div>
        </WithBackground>
    );
}
